import React, { useEffect, useState } from 'react'
import { Button, FormContext, FormInput, FormSubmitButton, GridView, InlineEditColumnProps, InlineEditTable, MasterDetailForm, SimpleView, Widget } from '@digital/ui'
import { TipoNaoPrevisto, createTipoNaoPrevisto, deleteTipoNaoPrevisto, getAllTipoNaoPrevisto, updateTipoNaoPrevisto } from '@app/api/naoPrevistos/parametros';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';

const CadastroTipo = () => {
    const [tipos, setTipos] = useState([])
    const [reload, setReload] = useState(false)
    const [initialValues, setInitialValues] = useState({})

    const onReload = () => {
        setReload(!reload)
    }

    useEffect(() => {
        getAllTipoNaoPrevisto().then((result) => {
            if (result) {
                setTipos(result)
            }
        })
    }, [reload])

    const handleCriar = (formProps: any) => {
        createTipoNaoPrevisto(formProps.values).then(data => {
            if (data) {
                onReload()
                formProps.resetForm()
            }
        })
    }

    const handleEditar = (data: any) => {
        updateTipoNaoPrevisto(data).then(data => {
            if (data) {
                onReload()
            }
        })
    }

    const handleDelete = (id: any) => {
        deleteTipoNaoPrevisto(id).then(data => {
            if (data) {
                onReload()
            }
        })
    }

    const customColumns = () => {
        return [
            {
                title: 'N',
                dataIndex: 'index',
                width: '1%',
            },
            {
                title: 'Tipo',
                dataIndex: 'nome',
                width: '90%',
                renderEdit: () => <FormInput name="nome" span={12} />,
            },
            {
                render: (item: TipoNaoPrevisto) =>
                    <Button
                        confirm="Deseja realmente excluir este registro?"
                        okText="Confirmar"
                        onClick={() => handleDelete(item.id)}
                        icon="commons-trash"
                    />
            },


        ] as InlineEditColumnProps<TipoNaoPrevisto>[];
    };

    return (
        <>
            <SimpleView>
                <GridView noform >
                    <MasterDetailForm
                        initialValues={initialValues}
                        onSubmit={handleCriar}
                        validationSchema={Yup.object().shape({
                            nome: Yup.string().required('Nome requerido')
                        })}
                    >
                        <FormContext.Consumer>
                            {({ formProps }) => (
                                <Widget
                                    title="Cadastro de Tipo do Motivador"
                                    actions={[
                                        hasPermission(["NAO_PREVISTO_PARAMETROS_EDITAR"]) && (
                                            <FormSubmitButton title='Salvar' type='primary' onClick={() => handleCriar(formProps)} />)
                                    ]}
                                >
                                    <FormInput label="Nome" name="nome" span={12} />
                                </Widget>
                            )}
                        </FormContext.Consumer>
                    </MasterDetailForm>
                    <Widget title="Tipos" >
                        <InlineEditTable
                            rowKey="id"
                            columns={customColumns()}
                            dataSource={tipos || []}
                            pagination={false}
                            updateItem={handleEditar}
                        />
                    </Widget>
                </GridView>
            </SimpleView>
        </>
    )
}

export default CadastroTipo